import { render } from "./AccommodationForm.vue?vue&type=template&id=455680eb"
import script from "./AccommodationForm.vue?vue&type=script&lang=js"
export * from "./AccommodationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__